import { CarePlanNoteQolGoalResponse } from '~/lib/types/carePlan/carePlans';
import { ChakraBox, ChakraFlex, Text } from '@equip.health/ui';
import { PatientNoteItemCarePlanStatusHistory } from '~/components/maud/patients/profile/tabs/patientNotesTab/PatientNoteItemCarePlanStatusHistory';
import { CarePlanGoalStatus } from '~/lib/types/carePlan/CarePlanGoalStatus';

type Props = {
  qolGoal: CarePlanNoteQolGoalResponse;
};
export const PatientNoteItemCarePlanQolGoal = ({ qolGoal }: Props) => {
  const description =
    qolGoal.description || qolGoal.descriptionDetails?.description;
  const isNotAssessed = qolGoal.status.code === CarePlanGoalStatus.NOT_ASSESSED;

  return (
    <ChakraFlex
      width="100%"
      direction="column"
      justifyContent="center"
      data-testid={`patient-note-item__qol-goal-card__${qolGoal.id}`}
    >
      <ChakraFlex alignItems="center" gap="12px">
        <Text
          variant="captionMedium"
          data-testid={`patient-note-item__qol-goal-title__${qolGoal.id}`}
        >
          {qolGoal.title}
        </Text>
        <PatientNoteItemCarePlanStatusHistory
          id={qolGoal.id}
          status={qolGoal.status}
          statusHistories={qolGoal.statusHistories}
        />
      </ChakraFlex>
      {!isNotAssessed && description && (
        <ChakraBox
          marginTop="8px"
          padding="12px"
          borderRadius="12px"
          bgColor="secondary.5"
          data-testid={`patient-note-item__qol-goal-description__${qolGoal.id}`}
        >
          <Text variant="caption">{description}</Text>
        </ChakraBox>
      )}
    </ChakraFlex>
  );
};
